import { render, staticRenderFns } from "./HipotekaTurtas.vue?vue&type=template&id=078b42d4&scoped=true&"
import script from "./HipotekaTurtas.vue?vue&type=script&lang=js&"
export * from "./HipotekaTurtas.vue?vue&type=script&lang=js&"
import style0 from "./HipotekaTurtas.vue?vue&type=style&index=0&id=078b42d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078b42d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VChip,VCol,VContainer,VDataTable,VDivider,VFooter,VIcon,VRow,VSpacer,VTextField,VToolbar})
